function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_23221_31795)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14zm0 2c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.49 8.95c0-.11.09-.2.2-.2h2.598c.11 0 .2.09.2.2v1.902a.2.2 0 01-.2.2H14.69a.2.2 0 01-.2-.2V8.95zm-1.303 12.173c0-.11.09-.2.2-.2h.365c.304 0 .521-.065.652-.195.13-.145.195-.362.195-.652v-4.659c0-.318-.058-.55-.174-.694-.1-.145-.31-.218-.63-.218h-.408a.2.2 0 01-.2-.2v-1.49c0-.11.09-.2.2-.2h3.857c.11 0 .2.09.2.2v7.304c0 .276.058.478.174.609.13.13.34.195.63.195h.364c.111 0 .2.09.2.2v1.49a.2.2 0 01-.2.2h-5.224a.2.2 0 01-.2-.2v-1.49z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_23221_31795"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));